import * as React from "react";

const SvgZoomout = ({ color, size }) => (
  <svg
    viewBox="0 0 24 24"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke={color}
      strokeWidth={2}
    >
      <path d="m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0ZM13 10.5H7" />
    </g>
  </svg>
);

export default SvgZoomout;
